import { fmhNpiAPI, NOTIFICATION_API_URL } from 'api/APIBase';

export async function getNotificationPreferences() {
    const url = `${NOTIFICATION_API_URL}/preferences/`;
    return fmhNpiAPI({ url }).get().json();
}

export function updateNotificationPreferences(preferences) {
    const url = `${NOTIFICATION_API_URL}/preferences/`;
    return fmhNpiAPI({ url }).post(preferences).json();
}
